// src/pages/Admin/VotePage/ui/VoteClubRulesPills.jsx

import React from "react";

import {
  FaBalanceScale,
  FaBuilding,
} from "react-icons/fa";

import { parseBoolean } from "../utils/voteAdmin.utils";

export default function VoteClubRulesPills({
  vote,
  className = "",
}) {
  const useClubWeight =
    parseBoolean(
      vote?.use_club_weight,
      false,
    );

  const oneVotePerClub =
    useClubWeight ||
    parseBoolean(
      vote?.one_vote_per_club,
      false,
    );

  if (
    !oneVotePerClub &&
    !useClubWeight
  ) {
    return null;
  }

  return (
    <div
      className={`flex flex-wrap gap-1.5 ${className}`}
    >
      {oneVotePerClub ? (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-indigo-50 px-2.5 py-1 text-[10px] font-black text-indigo-700 ring-1 ring-indigo-200 dark:bg-indigo-500/10 dark:text-indigo-300 dark:ring-indigo-500/20">
          <FaBuilding />
          1 vote / club
        </span>
      ) : null}

      {useClubWeight ? (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-orange-50 px-2.5 py-1 text-[10px] font-black text-orange-700 ring-1 ring-orange-200 dark:bg-orange-500/10 dark:text-orange-300 dark:ring-orange-500/20">
          <FaBalanceScale />
          Pondéré / 50 licenciés
        </span>
      ) : null}
    </div>
  );
}